/*
 * @Author: liyifan 
 * @Date: 2024-07-15 21:52:54 
 * @Last Modified by: liyifan
 * @Last Modified time: 2024-09-03 15:02:09
 * @description 首页--视频Banner
 */

import { isMobile  } from '@utils/index.js'
export class VideoBanner {
    constructor({el, clas}) {
        const name = isMobile() ? '.mb-video-container' : '.pc-video-container'
        this.DOM = {
            el: document.querySelector(`.${clas} ${name}`),
            video: document.querySelector(`.${clas} ${name} jky-video`),
            play: document.querySelector(`.${clas} ${name} .jky-video-play`), 
            pause: document.querySelector(`.${clas} ${name} .jky-video-pause`),
            turnOn: document.querySelector(`.${clas} ${name} .jky-video-turnOn`), 
            turnOff: document.querySelector(`.${clas} ${name} .jky-video-turnOff`),
        }
        const that = this
        setTimeout(() => {
            that.jkyVideoWrap = that.DOM.video

            if(that.jkyVideoWrap.videoInfo.type == 'mp4') {
                // 视频进入视口监听播放
                const deferredMediaObserver = new IntersectionObserver((entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            that.playVideoDisplay()
                        } else {
                            that.pauseVideoDisplay()  
                        }
                    });
                });
                if(this.DOM) {
                    deferredMediaObserver.observe(that.DOM.el)
                }
                that.onEvent()
            }
        }, 300)
        
    }

    onEvent() {
        const that = this
        const playEl = this.DOM.play
        playEl?.addEventListener('click', function() {
            // 执行暂停 
            that.jkyVideoWrap.pause()
            that.pauseVideoDisplay()  
        });

        const pauseEl = this.DOM.pause
        pauseEl?.addEventListener('click', function() { 
            that.jkyVideoWrap.loadContent(false)
             // 执行开始 
            that.playVideoDisplay()
        });

        // 开启声音
        const turnOnEl = this.DOM.turnOn
        turnOnEl?.addEventListener('click', function() { 
            if (that.jkyVideoWrap.deferredElement) {
                that.jkyVideoWrap.turnOnSound()
                that.turnOnVideoDisplay()
                
            }
        });
        // 关闭声音
        const turnOffEl = this.DOM.turnOff
        turnOffEl?.addEventListener('click', function() { 
            if (that.jkyVideoWrap.deferredElement) {
                that.jkyVideoWrap.turnoffSound()
                that.turnOffVideoDisplay()
            }
        });


        // 判断视频加载状态
        that.pauseVideoDisplay()
        that.jkyVideoWrap.onVideo(() => {
            that.DOM.turnOn.style.display = "flex"
            that.playVideoDisplay()
        })
    }

     // 播放
    playVideoDisplay(){
        this.DOM.play.style.display = "flex"
        this.DOM.pause.style.display = "none"
    }
    // 暂停
    pauseVideoDisplay(){
        this.DOM.play.style.display = "none"
        this.DOM.pause.style.display = "flex"
    }

     // 开启声音
     turnOnVideoDisplay(){
        this.DOM.turnOff.style.display = "flex"
        this.DOM.turnOn.style.display = "none"
    }
    // 关闭声音
    turnOffVideoDisplay(){
        this.DOM.turnOff.style.display = "none"
        this.DOM.turnOn.style.display = "flex"
    }
}